import axios from 'axios';


export function getDogs(){
    return async function(dispatch){
        var json = await axios.get('/api/dogs');
        return dispatch({
            type: 'GET_DOGS',// puede ir sin comillas
            payload: json.data
        })
    }
}
export function getNameDogs(name){
    return async function(dispatch){
        try {
            var json = await axios.get('/api/dogs?name='+ name);
            return dispatch ({
                type: "GET_NAME_DOGS", 
                payload: json.data
            })
        } catch (error) {
            alert("That Breed Does Not Exist")
        }
    }
}
export function orderByName(payload){
    return{
        type: 'ORDER_BY_NAME',
        payload
    }
}
export function filterApiCreated(order){
    return{
        type: 'FILTER_CREATED',
        payload: order
    }
}
export function orderByTemp(payload){
    return{
        type: 'ORDER_BY_TEMP',
        payload
    }
}
export function getTemperaments(){ // ** para crear el dog con temperaments
    return async function (dispatch){
        var info= await axios.get('/api/temperaments');
        return dispatch({
            type: 'GET_TEMPERAMENTS',
            payload: info.data
        });
    }
}

export function orderByWeight(payload){
    return{
        type: 'ORDER_WEIGHT',
        payload
    }
}
export function postDogs(payload){
    return async function(dispatch){
        const response = await axios.post('/api/dogs',payload);
        return response;
    }
}
export function getDetail(id){
    return async function (dispatch){ 
        try {
            var json = await axios('/api/dogs/'+ id);
            return dispatch({
                type: 'GET_DETAILS',
                payload: json.data
            });
        } catch (error) {
            console.log(error)
        }
    };
}

export async function ObtenerDogs(){
    const api = (await axios.get('/api/dogs')).data;
    const filtro = (await api.map((el)=>el.temperament))
    const filtro2 = filtro.trim()
    console.log(filtro2)
    return filtro2
}

